import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, styled } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { withTranslations } from '../../utils/withTranslations';

import { CompanyLeaderboardHeader } from './CompanyLeaderboardHeader';
import { CompanyLeaderboardList } from './CompanyLeaderboardList';
import { CompanyLeaderBoardUser } from './companyLeaderboardTypes';
import { LeaderboardNoScore } from './LeaderboardNoScore';

export interface CompanyLeaderboardProps {
  leaderBoard: CompanyLeaderBoardUser[];
  leaderBoardLoading: boolean;
  companyLeaderboard?: boolean;
}

export const StyledTaskContainer = styled(Box)(({ theme }) => {
  return {
    borderRadius: theme.spacing(3),
    border: '1px solid',
    borderColor: theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800],
    backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
    boxShadow: theme.customShadows.boxShadow,
  };
});

export const CompanyLeaderboard = withTranslations(({ leaderBoard, leaderBoardLoading }: CompanyLeaderboardProps) => {
  const { t } = useTranslation('components', { keyPrefix: 'leaderboard' });
  const [activeTeamTab, setTeamActiveTab] = useState(0);

  if (leaderBoardLoading) {
    return (
      <StyledTaskContainer display="flex" justifyContent="center" alignItems="center" width={392} height={200}>
        <CircularProgress />
      </StyledTaskContainer>
    );
  }

  const handleChangeActiveTab = (_: React.SyntheticEvent, tab: number) => {
    setTeamActiveTab(tab);
  };

  if (!leaderBoard.length) {
    return <LeaderboardNoScore title={t('noScoreTeamTitle')} description={t('noScoreTeam')} />;
  }

  const [bestRecording, ...restRecordings] = leaderBoard[activeTeamTab].leaderboard;

  if (!bestRecording || !leaderBoard.length) {
    return <LeaderboardNoScore title={t('noScoreTeamTitle')} description={t('noScoreTeam')} />;
  }

  return (
    <Box boxShadow={(theme) => theme.customShadows.boxShadow} sx={{ borderRadius: 4, height: 'fit-content' }}>
      <CompanyLeaderboardHeader
        fullName={bestRecording?.fullName}
        score={bestRecording?.score}
        activeTeamTab={activeTeamTab}
        onChangeActiveTab={handleChangeActiveTab}
        leaderBoard={leaderBoard}
      />
      <CompanyLeaderboardList list={restRecordings} />
    </Box>
  );
});
